import React, { useState, useRef, useEffect } from 'react'
import { urlValue, unfolder, openAlert, useTranslate, downloadFile }
  from '../../../lib'
import { InputNesting, TextareaNesting } from '../../common/Inputs/Input'
import { SelectNesting } from '../../common/Inputs/Select'
import ButtonYesNo from '../../common/ButtonYesNo'
import ExcelUploadButton from '../ExcelUploadButton'
import BoxInfo from '../../common/BoxInfo'
import CheckBox2 from '../../CheckBox2'
import { AddCategoryModal } from '../../AddCategoryModal';
import { AddEvaluationCriteriaModal } from '../../AddEvaluationCriteriaModal';
import axios from 'axios'

export default function EvaluationSettings({
  showEvaluation,
  setShowEvaluation,
  questions,
  setQuestions,
  useValueQuestion,
  setUseValueQuestion,
  categoriesApi,
  loadingCategories,
  setCategoriesApi,
  deleteQuestiong,
  handleAutofailChange,
  addQuestiong,
  addCategoryModal,
  industry_ref,
  customEvaluation,
  setCustomEvaluation,
  channel,
  overwriteSubcampaign,
  setOverwriteSubcampaign,
  overwriteSubcampaignProjects,
}) {
  const { t } = useTranslate()
  const [alert, setAlert] = useState({ title: '', visible: false })
  const [questionChange, setQuestionChange] = useState("")
  const [isAddCategoryModalOpen, setIsAddCategoryModalOpen] = useState(false);
  const [isAddEvaluationCriteriaModalOpen, setIsAddEvaluationCriteriaModalOpen] = useState(false);
  const [selectedIndustry, setSelectedIndustry] = useState('Other');

  // Sincronizar selectedIndustry con el valor del ref cuando se carga
  useEffect(() => {
    if (industry_ref?.current?.value) {
      setSelectedIndustry(industry_ref.current.value);
    }
  }, [industry_ref?.current?.value]);

  // Si hay custom evaluation seleccionado, forzar industry a Custom
  useEffect(() => {
    if (customEvaluation?.selected_custom_evaluation_id && customEvaluation?.selected_custom_evaluation_id > 0) {
      setSelectedIndustry('Custom');
      if (industry_ref?.current) {
        industry_ref.current.value = 'Custom';
      }
    }
  }, [customEvaluation?.selected_custom_evaluation_id]);

  const logsQuestions = useRef('');

  const industries = [
    { id: 1, name: "BFSI" },
    { id: 2, name: "Gaming" },
    { id: 3, name: "News & Media" },
    { id: 4, name: "Tech App Food & Delivery" },
    { id: 5, name: "Tech-Home Services" },
    { id: 6, name: "Telecom" },
    { id: 7, name: "Travel & Hospitality" },
    { id: 8, name: "Other" },
    { id: 9, name: "Custom" },
  ]

  const onChangeQuestion = (e, index) => {
    if (e.target.value.includes('"')) {
      openAlert('#alert-ac', () => { setAlert({ title: t('alerts.doubleQuotesQuestion'), visible: true, error: true }) }, 4000, () => { setAlert({ ...alert, visible: false }) });
    }
    const q = [...questions];
    q[index].question = e.target.value
    setQuestions(q)
  }

  const onChangeSuggested = (e, index) => {
    const q = [...questions];
    q[index].suggested = e.target.value
    setQuestions(q)
  }

  const onFocusQuestion = (e, index) => {
    console.log("Foco en la pregunta")
    setQuestionChange(e.target.value)
  }

  const onBlurQuestion = (e, index) => {
    if (questionChange != e.target.value) {
      if (questionChange === '') {
        logsQuestions.current += `Add Question -> ${e.target.value}\n`;
      } else {
        logsQuestions.current += `Modify Question Before -> ${questionChange} After -> ${e.target.value}\n`;
      }
    }
  }

  const onChangeValue = (e, index) => {
    const q = [...questions];
    q[index].value = e.target.value
    setQuestions(q)
  }

  const onChangeCategory = (e, index) => {
    const q = [...questions];
    q[index].category = e.target.value;
    setQuestions(q);
  };

  const handleOpenAddCategoryModal = () => {
    setIsAddCategoryModalOpen(true);
  };

  const handleCloseAddCategoryModal = () => {
    setIsAddCategoryModalOpen(false);
  };

  const handleOpenAddEvaluationCriteriaModal = () => {
    setIsAddEvaluationCriteriaModalOpen(true);
  };

  const handleCloseAddEvaluationCriteriaModal = () => {
    setIsAddEvaluationCriteriaModalOpen(false);
  };

  const handleEvaluationCriteriaAdded = (evaluationData) => {
    // Agregar nueva evaluación al arreglo
    const newEvaluation = {
      id: Date.now(),
      name: evaluationData.name,
      evaluation_structure: evaluationData.evaluation_structure
    };
    
    const currentEvaluations = customEvaluation?.evaluations || [];
    const updatedEvaluations = [...currentEvaluations, newEvaluation];
    
    setCustomEvaluation({
      ...customEvaluation,
      evaluations: updatedEvaluations,
      selected_custom_evaluation_id: newEvaluation.id
    });
    
    // Cambiar industry a Custom
    setSelectedIndustry('Custom');
    if (industry_ref?.current) {
      industry_ref.current.value = 'Custom';
    }
    
    openAlert('#alert-ac', () => {
      setAlert({ title: t('menu.genai.customCriteriaSaved'), visible: true })
    }, 4000, () => {
      setAlert({ ...alert, visible: false })
    });
  };

  const handleIndustryChange = (e) => {
    const value = e.target.value;
    setSelectedIndustry(value);
    
    // Si no es Custom, resetear selected_custom_evaluation_id
    if (value !== 'Custom') {
      setCustomEvaluation({
        ...customEvaluation,
        selected_custom_evaluation_id: 0
      });
    }
  };

  const handleCustomEvaluationSelect = (e) => {
    const selectedId = parseInt(e.target.value);
    setCustomEvaluation({
      ...customEvaluation,
      selected_custom_evaluation_id: selectedId
    });
  };

  const createCategory = async (categoryName) => {
    let token = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').token;
    let id = unfolder(localStorage.getItem('hashInfo'), 'IANestingKey').id;
    let csrfToken = unfolder(localStorage.getItem('hashUser'), 'IANestingKey').csrfToken

    try {
      const response = await axios({
        method: 'post',
        url: `${urlValue}/studio/categories`,
        headers: {
          'access-token': token,
          user: id,
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken
        },
        data: {
          name: categoryName,
        },
        withCredentials: true,
      });

      if (response.status === 200 || response.status === 201) {

        const newCategory = { id: response.data.id || Date.now(), name: categoryName };
        setCategoriesApi(prev => [...prev, newCategory]);

        openAlert('#alert-ac', () => {
          setAlert({ title: 'Category created successfully!', visible: true })
        }, 4000, () => {
          setAlert({ ...alert, visible: false })
        });

        return newCategory;
      }
    } catch (error) {
      console.error('Error creating category:', error);

      if (error.response?.status === 409 || error.response?.data?.message?.includes('already exists')) {
        throw new Error('A category with this name already exists');
      } else {
        throw new Error('Error creating category. Please try again.');
      }
    }
  };

  return (
    <>
      {/* ENCABEZADO */}
      <div
        className='w-100 mt-1 shadow_box'
        style={{
          backgroundColor: '#0088ff09',
          padding: 10,
          borderRadius: '10px 10px 0 0',
        }}
      >
        <div className='d-flex flex-row align-items-center justify-content-between w-100'>
          <h2 onClick={() => setShowEvaluation(!showEvaluation)} className='m-0' style={{ color: '#0B5FA3', fontSize: 15, cursor: "pointer" }}>
            {t('menu.genai.evaluationFormulary')}
          </h2>
          <button
            id='arrow-down-btn'
            className='ml-3'
            type='button'
            onClick={() => setShowEvaluation(!showEvaluation)}
          >
            <img src={showEvaluation ? '/icons/arrow_up.png' : '/icons/arrow_down.png'} style={{ width: 15 }} alt='' />
          </button>
        </div>

      </div>

      {/* CONTENIDO DESPLEGABLE */}
      <div
        style={{
          display: showEvaluation ? 'flex' : 'none',
          backgroundColor: '#0088ff09',
          padding: '5px 10px 10px 10px',
          position: 'relative'
        }}
        className='flex-column w-100 pt-3'
      >
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', gap: 12, flexWrap: 'wrap', marginTop: 10, marginBottom: 0, width: '100%' }}>
          <div className='d-flex flex-row align-items-center' style={{ gap: 6 }}>
            <BoxInfo
              id="overwriteSubcampaign" titleClass='mr-0-4' styles={{ marginBottom: 0 }}
              title={t('menu.genai.applyToSubcampaign') || 'Apply to all subcampaign projects'}
              place="top" containerClass='mr-0-5'
              content={t('menu.genai.applyToSubcampaignTooltip') || 'Enable to overwrite settings on all projects in the selected subcampaign'}
            />
            <ButtonYesNo
              onClick={() => setOverwriteSubcampaign((prev) => !prev)}
              width={140}
              state={overwriteSubcampaign}
              height={30}
            />
          </div>
          <ExcelUploadButton
            onQuestionsLoaded={(loadedQuestions) => {
              setQuestions(loadedQuestions);
              if (overwriteSubcampaign) {
                overwriteSubcampaignProjects(loadedQuestions);
              }
            }}
            useValueQuestion={useValueQuestion}
          />
        </div>

        <div className='flex  flex-col pb-4 mt-1'>
          <div className='flex flex-column' style={{ minWidth: 175, marginBottom: 15 }}>
            <BoxInfo
              id="questionValue" titleClass='mr-0-4' styles={{ marginBottom: 10 }}
              title={t('menu.genai.questionValue')}
              place="top" containerClass='mr-0-5 '
              content={t('menu.genai.questionValueTooltip')}
            />
            <ButtonYesNo
              onClick={() => setUseValueQuestion((prev) => !prev)}
              width={140}
              state={useValueQuestion}
              height={30}
            />
          </div>
          {questions?.map((item, index) => (
            <div style={{ borderBottom: '1px solid #A1A1A0', paddingBottom: 30, marginTop: index !== 0 ? 30 : 0 }}>
              <div key={item.id} className='flex items-end flex-1'>
                <InputNesting
                  containerClass="w-full"
                  defaultValue={item.question}
                  onChange={(e) => onChangeQuestion(e, index)}
                  title={`${t('common.question')} ${index + 1}:`}
                  onFocus={(e) => onFocusQuestion(e, index)}
                  onBlur={(e) => onBlurQuestion(e, index)}
                />
                <button type='button' className='ml-2 btn-delete  ' style={{ marginBottom: 3 }} onClick={() => deleteQuestiong(item.id)} >
                  <img src={'/icons/trash-1.png'} alt='' style={{ width: 22 }} />
                </button>
              </div>
              <div key={`valuequestion ${item.id}:`} className='flex items-end flex-wrap flex-1 mt-2' style={{ alignItems: 'center' }}>
                <InputNesting
                  containerClass="w-full"
                  defaultValue={item?.suggested}
                  onChange={(e) => onChangeSuggested(e, index)}
                  title={`${t('menu.feedback')} ${index + 1}:`}
                />
                <InputNesting
                  defaultValue={item?.value}
                  onChange={(e) => onChangeValue(e, index)}
                  title={`${t('common.value')} ${index + 1}:`}
                  disabled={!useValueQuestion}
                  contentStyle={{ width: '70px', margin: '16px 0 10px 5px' }}
                />
                <div style={{ minWidth: 130, display: 'flex', flexDirection: 'column', margin: 10 }}>
                  <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                    <p style={{ fontSize: 14, color: "#2E2E2E", fontWeight: '700' }}>{t('menu.genai.category')}:</p>
                    <button
                      type='button'
                      onClick={handleOpenAddCategoryModal}
                      className='btn-add'
                      style={{
                        minWidth: '36px',
                        height: '36px',
                        padding: '6px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        // backgroundColor: 'white',
                        border: 'none',
                        borderRadius: '4px',
                        cursor: 'pointer'
                      }}
                      title={t('menu.genai.newCategory')}
                    >
                      <img src='/icons/add-icon-nt.png' style={{ width: 18, height: 18 }} alt={t('menu.genai.newCategory')} />
                    </button>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                    <p>{item?.category}</p>
                    <SelectNesting
                      boxInfo={false}
                      tooltipText={t('menu.genai.category')}
                      title="" containerClass="d-flex"
                      style={{ minWidth: 188 }}
                      defaultValue={item?.category}
                      onChange={e => onChangeCategory(e, index)}
                    >
                      {loadingCategories && <option>{t('common.loading')}...</option>}
                      {!loadingCategories && categoriesApi && categoriesApi.length > 0 ? (
                        categoriesApi.map(cat => (
                          <option key={cat.id || cat.name} value={cat.name}>{cat.name}</option>
                        ))
                      ) : (
                        !loadingCategories && <option value="">Without categories</option>
                      )}
                    </SelectNesting>
                  </div>
                </div>
                <div key={`checkautofail ${item.id}:`} className=' flex flex-column' style={{ marginLeft: '20px' }}>
                  <label className="title-color"><b></b>{t('menu.genai.autoFail')}:</label>
                  <CheckBox2 onChange={() => { handleAutofailChange(index) }}
                    checked={item?.autofail === 1} id={`ck-autofail-${item.id}`} text="Autofail" />

                </div>
              </div>
            </div>
          ))}
          <button className='btn-add mt-2' type='button' onClick={addQuestiong}>
            <img src='/icons/add-icon-nt.png' style={{ width: 22, minWidth: 25 }} alt='' />
            <span className='ml-5'>{t('menu.genai.addQuestion')}</span>
          </button>
        </div>


        <div style={{ display: 'flex', alignItems: 'flex-end', gap: '10px', flexWrap: 'wrap' }}>
          <div style={{ minWidth: 250 }}>
            <SelectNesting
              ref={industry_ref} 
              id="industry"
              title={`${t('common.industry')}:`} 
              containerClass=" mr-2" 
              defaultValue={industries.find(item => item.id === 8)?.name}
              onChange={handleIndustryChange}
            >
              {industries.map((item, index) => (<option key={index} value={item.name}>{item.name}</option>))}
            </SelectNesting>
          </div>
          
          {/* Mostrar selector y botón solo cuando industry es Custom */}
          {selectedIndustry === 'Custom' && (
            <>
              <div style={{ minWidth: 300, flexGrow: 1 }}>
                <SelectNesting
                  id="custom_evaluation_select"
                  title={`${t('menu.genai.selectCustomEvaluation')}:`}
                  containerClass="mr-2"
                  value={customEvaluation?.selected_custom_evaluation_id || 0}
                  onChange={handleCustomEvaluationSelect}
                >
                  <option value={0}>{t('menu.genai.selectOption')}</option>
                  {customEvaluation?.evaluations?.map((evaluation) => (
                    <option key={evaluation.id} value={evaluation.id}>
                      {evaluation.name}
                    </option>
                  ))}
                </SelectNesting>
              </div>
              
              <button
                type='button'
                onClick={handleOpenAddEvaluationCriteriaModal}
                className='btn-add'
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  marginBottom: '10px',
                  whiteSpace: 'nowrap'
                }}
                title={t('menu.genai.createNewEvaluation')}
              >
                <img src='/icons/add-icon-nt.png' style={{ width: 18, height: 18 }} alt={t('menu.genai.createNewEvaluation')} />
                <span>{t('menu.genai.createNewEvaluation')}</span>
              </button>
            </>
          )}
        </div>

        {/* Grammar Evaluation Criteria - Solo visible si channel es chat */}
        {channel === 'chat' && (
          <div style={{ marginTop: '15px', maxWidth: '100%' }}>
            <label style={{ 
              fontSize: '14px', 
              color: '#2E2E2E', 
              fontWeight: '700',
              display: 'block',
              marginBottom: '8px'
            }}>
              {t('menu.genai.grammarEvaluationCriteria') || 'Grammar Evaluation Criteria'}:
            </label>
            <div style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: '8px',
              padding: '10px',
              backgroundColor: '#f9f9f9',
              borderRadius: '6px',
              border: '1px solid #ddd'
            }}>
              {(() => {
                // Convertir string a array si es necesario
                let currentCriteria = customEvaluation?.grammar_criteria || 'all';
                if (typeof currentCriteria === 'string') {
                  currentCriteria = currentCriteria.split(',').map(c => c.trim()).filter(c => c);
                }
                
                return (
                  <>
                  <label style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '6px 12px',
                    backgroundColor: currentCriteria.includes('all') ? '#0087FF' : '#fff',
                    color: currentCriteria.includes('all') ? '#fff' : '#333',
                    border: '1px solid #0087FF',
                    borderRadius: '4px',
                    cursor: 'pointer',
                    fontSize: '13px',
                    fontWeight: currentCriteria.includes('all') ? '600' : '400',
                    transition: 'all 0.2s'
                  }}>
                    <input
                      type="checkbox"
                      value="all"
                      checked={currentCriteria.includes('all')}
                      onChange={(e) => {
                        let newCriteria;
                        if (e.target.checked) {
                          newCriteria = ['all'];
                        } else {
                          newCriteria = currentCriteria.filter(c => c !== 'all');
                        }
                        setCustomEvaluation({
                          ...customEvaluation,
                          grammar_criteria: newCriteria
                        });
                      }}
                      style={{ marginRight: '6px' }}
                    />
                    {t('common.all') || 'All'}
                  </label>

                  {['spelling', 'punctuation', 'capitalization', 'verb_conjugation', 'word_usage'].map((criterion) => {
                    return (
                      <label
                        key={criterion}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          padding: '6px 12px',
                          backgroundColor: currentCriteria.includes(criterion) ? '#E3F2FD' : '#fff',
                          color: '#333',
                          border: '1px solid #90CAF9',
                          borderRadius: '4px',
                          cursor: 'pointer',
                          fontSize: '13px',
                          transition: 'all 0.2s'
                        }}
                      >
                        <input
                          type="checkbox"
                          value={criterion}
                          checked={currentCriteria.includes(criterion)}
                          onChange={(e) => {
                            let newCriteria;
                            
                            if (e.target.checked) {
                              // Agregar el criterio (y quitar 'all' si estaba)
                              newCriteria = [...currentCriteria.filter(c => c !== 'all'), criterion];
                            } else {
                              // Quitar el criterio
                              newCriteria = currentCriteria.filter(c => c !== criterion);
                            }
                            
                            setCustomEvaluation({
                              ...customEvaluation,
                              grammar_criteria: newCriteria.length > 0 ? newCriteria : ['all']
                            });
                          }}
                          style={{ marginRight: '6px' }}
                        />
                        {t(`menu.genai.grammar.${criterion}`) || criterion.replace('_', ' ')}
                      </label>
                    );
                  })}
                </>
              );
            })()}
          </div>
          <div style={{ 
            fontSize: '12px', 
            color: '#666', 
            marginTop: '6px',
            fontStyle: 'italic'
          }}>
            {t('menu.genai.grammarCriteriaHelp') || 'Select any criteria (multiple selection allowed)'}
          </div>
        </div>
        )}
        <div className='d-flex flex-row w-100 mt-2 pb-2'>
          <BoxInfo
            id="evaluationcriteria"
            titleClass='w-100'
            title={t('menu.genai.evaluationCriteria') + ':'}
            place="top"
            containerClass='mr-0-5'
            content={t('menu.genai.toolTipEvaluationCriteria')}
          />

          <div className="input" style={{ marginLeft: 10, }}>
            <div style={{ cursor: 'pointer' }} onClick={() => { downloadFile("EvaluationCriteria.csv") }} className="a-download trans btn-excel">
              <img src="/icons/download-icon.svg" alt="Img Template" style={{ width: 15, marginRight: 5 }} />
              Download Excel
            </div>
          </div>

        </div>

      </div>
      <AddCategoryModal
        isOpen={isAddCategoryModalOpen}
        onClose={handleCloseAddCategoryModal}
        onCategoryAdded={createCategory}
        existingCategories={categoriesApi}
      />
      <AddEvaluationCriteriaModal
        isOpen={isAddEvaluationCriteriaModalOpen}
        onClose={handleCloseAddEvaluationCriteriaModal}
        onEvaluationCriteriaAdded={handleEvaluationCriteriaAdded}
      />
    </>
  )
}
